const sendCustomSymplifyValue = (value?: string) => {
  if (window.symplify && value) {
    window.symplify.customValue.set(value);
  }
};
export default sendCustomSymplifyValue;
